import useSEO from "@/hooks/useSEO";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Datenschutz() {
  useSEO({
    title: "Datenschutzerklärung · Niko's Grill Bochum",
    description: "Datenschutzerklärung von Niko's Grill, Höntroper Str. 2, 44869 Bochum.",
    path: "/datenschutz",
  });

  return (
    <main className="bg-[var(--niko-cream)]" data-testid="datenschutz-page">
      <Navbar />
      <section className="pt-40 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[var(--niko-charcoal)]/65 hover:text-[var(--niko-blue)] transition-colors mb-10"
            data-testid="back-home"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>

          <p className="divider-leaf max-w-[150px] mb-6">DSGVO</p>
          <h1 className="font-display text-5xl md:text-6xl text-[var(--niko-charcoal)] leading-[1.05]">
            Datenschutzerklärung
          </h1>

          <div className="mt-12 space-y-10 text-[var(--niko-charcoal)]/85 leading-[1.85] text-base">
            <Block title="1. Verantwortlicher">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              <br />
              <br />
              Anastasios Denesakis
              <br />
              Niko's Grill
              <br />
              Höntroper Str. 2, 44869 Bochum
              <br />
              Telefon: +49 2327 995454
              <br />
              E-Mail: NikosGrillBochum@gmail.com
            </Block>

            <Block title="2. Allgemeines">
              Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
              behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
              den gesetzlichen Datenschutzvorschriften (DSGVO, BDSG) sowie
              dieser Datenschutzerklärung.
            </Block>

            <Block title="3. Erhebung allgemeiner Informationen beim Besuch unserer Website">
              Wenn Sie auf unsere Website zugreifen, werden automatisch
              Informationen allgemeiner Natur erfasst (Browsertyp, Betriebssystem,
              Domainname, Datum und Uhrzeit des Zugriffs). Diese Informationen
              werden technisch notwendig erfasst, um Ihnen die Inhalte unserer
              Website korrekt auszuliefern. Eine personenbezogene Auswertung
              findet nicht statt.
            </Block>

            <Block title="4. Kontaktaufnahme">
              Wenn Sie uns telefonisch oder per E-Mail kontaktieren, werden
              Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage
              verwendet. Eine Speicherung über diese Website erfolgt nicht.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO.
            </Block>

            <Block title="5. Google Maps">
              Auf dieser Website ist ein Karten-Ausschnitt von Google Maps
              eingebettet (Anbieter: Google Ireland Limited, Gordon House,
              Barrow Street, Dublin 4, Irland). Beim Aufruf der Karte werden
              Daten an Google übermittelt (IP-Adresse, Zeitpunkt). Wir nutzen
              Google Maps zur ansprechenden Darstellung unseres Standortes.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Weitere
              Informationen: https://policies.google.com/privacy
            </Block>

            <Block title="6. Cookies">
              Diese Website verwendet keine Tracking-Cookies und keine
              Analyse-Tools. Es werden lediglich technisch notwendige Cookies
              eingesetzt, soweit erforderlich.
            </Block>

            <Block title="7. Ihre Rechte">
              Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO),
              Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO),
              Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit
              (Art. 20 DSGVO) sowie Widerspruch (Art. 21 DSGVO). Wenden Sie sich
              dazu an die oben genannten Kontaktdaten.
            </Block>

            <Block title="8. Beschwerderecht">
              Sie haben das Recht, sich bei einer Aufsichtsbehörde zu
              beschweren. Zuständig ist die Landesbeauftragte für Datenschutz
              und Informationsfreiheit Nordrhein-Westfalen.
            </Block>

            <p className="text-sm text-[var(--niko-charcoal)]/55 pt-6 border-t border-[var(--niko-charcoal)]/10">
              Stand: 2026
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl text-[var(--niko-blue)] mb-3">
        {title}
      </h2>
      <div>{children}</div>
    </div>
  );
}
